import { useChat } from "./useChat";

/** Thin wrapper around {@link useChat} for call sites that historically synced members into Redux. */
export const useWrappedChat = (opts: Parameters<typeof useChat>[0]) => useChat(opts);
